import { useEffect, useCallback } from 'react';
const InjectHighCPU = () => {
  const performHeavyCalculation = useCallback(() => {
    let expensiveCalculation = 0;
    const secondaryCalculation = 0;
    let tertiaryCalculation = 0;
    for (let i = 0; i < 50000; i++) {
      for (let j = 0; j < 2000; j++) {
        const angle = i * j * 0.001;
        const sinAngle = Math.sin(angle);
        const cosAngle = Math.cos(angle * 2);
        const tanAngle = Math.tan(angle * 0.5);
        const complexTrig = isFinite(sinAngle) && isFinite(cosAngle) && isFinite(tanAngle) ? sinAngle * cosAngle * tanAngle : 0;
        const absComplexTrig = Math.abs(complexTrig);
        const expLog = isFinite(absComplexTrig) ? Math.exp(Math.log(absComplexTrig + 1) * 0.1) : 0;
        const base = Math.abs(Math.sin(i * 0.01));
        const exponent = Math.cos(j * 0.01);
        const powerOp = base > 0 || exponent >= 0 ? Math.pow(base, exponent) : 0;
        const sinSum = Math.abs(Math.sin(i + j));
        const cosSum = Math.abs(Math.cos(i - j));
        const sqrtChain = Math.sqrt(Math.sqrt(sinSum) + Math.sqrt(cosSum));
        const hyperbolic = isFinite(angle) ? Math.sinh(angle * 0.1) * Math.cosh(angle * 0.1) * Math.tanh(angle * 0.1) : 0;
        const currentSum = complexTrig + expLog + powerOp + sqrtChain + hyperbolic;
        if (isFinite(currentSum)) {
          expensiveCalculation += currentSum;
        }
      }
      if (i % 100 === 0) {
        for (let m = 0; m < 1000; m++) {
          const sinM = Math.sin(m * 0.001);
          const cosM = Math.cos(m * 0.001);
          const tanM = Math.tan(m * 0.0001);
          if (isFinite(sinM) && isFinite(cosM) && isFinite(tanM)) {
            const expResult = Math.pow(Math.E, sinM);
            const logResult = Math.log(Math.abs(cosM) + 1);
            const sqrtResult = Math.sqrt(Math.abs(tanM));
            if (isFinite(expResult) && isFinite(logResult) && isFinite(sqrtResult)) {
              tertiaryCalculation += expResult * logResult * sqrtResult;
            }
          }
        }
      }
    }
    const finalResult = expensiveCalculation + secondaryCalculation + tertiaryCalculation;
    return isFinite(finalResult) ? finalResult : 0;
  }, []);
  useEffect(() => {
    setTimeout(() => {
      const __result = performHeavyCalculation();
    }, 2000);
  }, [performHeavyCalculation]);
  return null;
};
export default InjectHighCPU;